import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2c7e50',
        primaryLight: '#62a478',
        secondary: '#f8f6a3',
        secondaryLight: '#fafac8',
        tertiary: '#376460',
        tertiaryLight: '#ceecec',
        grayWording: '#878787'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
});
